export default import.meta.ROLLDOWN_FILE_URL_MVdo97JDDoLmTAG1uzKtGg